const PG_AP_WORK_CONTENT = [
  { title: "Get 30%", subTitle: "From every sale you deliver" },
  { title: "$150", subTitle: "Average order value" },
  { title: "30 days", subTitle: "Cookie lifetime" },
]

export default PG_AP_WORK_CONTENT
